import { render } from "./FormCheckout.vue?vue&type=template&id=0ad67a38&ts=true"
import script from "./FormCheckout.vue?vue&type=script&lang=ts"
export * from "./FormCheckout.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__